/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const Progress = core.serialization.object({
    current: core.serialization.number().optional(),
    total: core.serialization.number().optional(),
    percent: core.serialization.number().optional(),
});
